import { Gender } from '@/types/auth-base.types';
import { ProfessionalCrmSuffixContext, resolveProfessionalGender } from '@/utils/professional/professional-license.util';

export const POST_GRADUATION_FORMATION_TYPES = [
  'POSTGRADUATE',
  'MASTERS_DEGREE',
  'DOCTORATE_DEGREE',
  'POST_DOCTORATE',
];

export const PROFESSIONAL_FORMATIONS_SECTION_ID = 'formacao';

export const getProfessionalFormationsPath = (slug?: string | null): string | undefined =>
  slug ? `/profissionais/${slug}/#${PROFESSIONAL_FORMATIONS_SECTION_ID}` : undefined;

export interface MainPostGraduation {
  description: string;
  othersCount: number;
}

interface FormationSource {
  type?: string | null;
  description?: string | null;
  isMainPostGraduation?: boolean | null;
}

const isPostGraduation = (formation: FormationSource): boolean =>
  POST_GRADUATION_FORMATION_TYPES.includes(formation.type ?? '');

export const getMainPostGraduation = (formations?: FormationSource[] | null): MainPostGraduation | null => {
  const postGraduations = (formations ?? []).filter(isPostGraduation);
  const main = postGraduations.find((formation) => formation.isMainPostGraduation && formation.description?.trim());

  if (!main) {
    return null;
  }

  return {
    description: main.description?.trim() ?? '',
    othersCount: postGraduations.length - 1,
  };
};

const POST_GRADUATE_BY_GENDER = {
  [Gender.MALE]: 'Pós-graduado',
  [Gender.FEMALE]: 'Pós-graduada',
};

export const formatMainPostGraduationTitle = (
  { description }: MainPostGraduation,
  context: ProfessionalCrmSuffixContext,
): string => {
  const gender = resolveProfessionalGender(context);
  const postGraduate = gender ? POST_GRADUATE_BY_GENDER[gender] : 'Pós-graduado(a)';

  return `${postGraduate} em ${description}`;
};

export const formatOtherPostGraduations = (othersCount: number): string =>
  `+${othersCount} ${othersCount === 1 ? 'pós-graduação' : 'pós-graduações'}`;
